import api from "../service";
import { configApp, hotToast } from "../utils";
import { messagesLevel } from "utils";

export const getBrandsSC = async () => {
  return await api
    .requestGet(`${configApp.seguridad_v1}api/Marca?`)
    .then((res) => {
      const { message, code, result } = res.data as any;
      if (!res.ok || code !== 100) {
        hotToast(message || messagesLevel("read", "obtener marcas"), "ERROR");
        return false;
      }
      return result;
    })
    .catch((error) => {
      hotToast(messagesLevel("unknown"), "ERROR");
      return false;
    });
};

export const getOperationTypesSCById = async (idBrand: number) => {
  return await api
    .requestGet(
      `${configApp.seguridad_v1}api/TipoDeOperacion?idMarca=${idBrand}`
    )
    .then((res) => {
      const { message, code, result } = res.data as any;
      if (!res.ok || code !== 100) {
        hotToast(message || messagesLevel("read", "obtener marcas"), "ERROR");
        return false;
      }
      return result;
    })
    .catch((error) => {
      hotToast(messagesLevel("unknown"), "ERROR");
      return false;
    });
};
